import { createFileRoute } from '@tanstack/react-router';

import { schema } from 'routes/_private/_route/_internal/people/$identityId/_candidate/performance/index.route';

/** Forwards to `/people/:identityId` (see the parent route). */
export const Route = createFileRoute(
  '/_private/_route/_internal/candidates/$candidateId/recommendations/',
)({
  validateSearch: schema,
});
